export default __webpack_public_path__ + "static/media/cardPO.4eb83d86.svg";